import React, {useState} from "react";
import {FormControlLabel} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./ManualScore.css";
import {makeStyles} from '@mui/styles';
import OrangeSwitch from "../../OrangeSwitch";

const useStyles = makeStyles((theme) => ({
    switchLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
}));


const ManualScorePersonalDetails = ({updateScore, cvScore}) => {

    const classes = useStyles();
    const [personalDetailsScore, setPersonalDetailsScore] = useState(cvScore);

    const handlePersonalDetailsChange = (e) => {
        let { name, checked } = e.target;

        setPersonalDetailsScore((prevScore) => ({
            ...prevScore,
            [name]: (checked),
        }));

        updateScore("personalDetailsScore", {...personalDetailsScore, [name] : checked})
    }

    return (
        <Box className={"scoringBox"} data-testid={"manualScoreBox"}>
            <Grid container padding={2} spacing={2}>
                <Grid item xs={12}>
                    <h3>
                        Personal Details
                    </h3>
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<OrangeSwitch/>}
                        style={{width: "100%", marginLeft: "0px"}}
                        label="Name provided"
                        name={"name"}
                        checked={personalDetailsScore?.name}
                        data-testid={"name"}
                        classes={{label: classes.switchLabel}}
                        labelPlacement="start"
                        onChange={(e) => {handlePersonalDetailsChange(e)}}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        style={{width: "100%", marginLeft: "0px"}}
                        control={<OrangeSwitch/>}
                        name={"dob"}
                        checked={personalDetailsScore?.dob}
                        label="Date of birth correspond to ID"
                        labelPlacement="start"
                        data-testid={"dob"}
                        classes={{label: classes.switchLabel}}
                        onChange={(e) => {handlePersonalDetailsChange(e)}}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        style={{width: "100%", marginLeft: "0px"}}
                        control={<OrangeSwitch/>}
                        label="Can be contacted"
                        checked={personalDetailsScore?.contactable}
                        name={"contactable"}
                        labelPlacement="start"
                        data-testid={"contactable"}
                        classes={{label: classes.switchLabel}}
                        onChange={(e) => {handlePersonalDetailsChange(e)}}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        style={{width: "100%", marginLeft: "0px"}}
                        control={<OrangeSwitch/>}
                        label="SA Citizen"
                        name={"rsaCitizen"}
                        checked={personalDetailsScore?.rsaCitizen}
                        labelPlacement="start"
                        data-testid={"rsaCitizen"}
                        classes={{label: classes.switchLabel}}
                        onChange={(e) => {handlePersonalDetailsChange(e)}}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        style={{width: "100%", marginLeft: "0px"}}
                        control={<OrangeSwitch/>}
                        label="Drivers license"
                        checked={personalDetailsScore?.driversLicense}
                        labelPlacement="start"
                        data-testid={"driversLicense"}
                        name={"driversLicense"}
                        onChange={(e) => {handlePersonalDetailsChange(e)}}
                        classes={{label: classes.switchLabel}}
                    />
                </Grid>

                <Grid item xs={12}>
                    <FormControlLabel
                        style={{width: "100%", marginLeft: "0px"}}
                        control={<OrangeSwitch/>}
                        label="LinkedIn Profile"
                        checked={personalDetailsScore?.linkedIn}
                        onChange={(e) => {handlePersonalDetailsChange(e)}}
                        name={"linkedIn"}
                        data-testid={"linkedIn"}
                        labelPlacement="start"
                        classes={{label: classes.switchLabel}}
                    />
                </Grid>

            </Grid>
        </Box>
    )
}
export default ManualScorePersonalDetails;